import React, { useRef, useState, useEffect, memo } from 'react';
import { ProgressBar, Spinner } from 'react-bootstrap';
import { isMobile } from 'react-device-detect';
import ReactPlayer from 'react-player';
import useRedirect from '../customHooks/useRedirect';
import LazyImage from '../CustomLibraries/LazyImage';
import { RiPlayCircleFill } from '../icons';
import 'swiper/css';
import 'swiper/css/navigation';
import 'swiper/css/pagination';

import { Swiper, SwiperSlide } from 'swiper/react';
import SwiperCore, { Pagination, Navigation } from 'swiper';
import { clinical_Video_static_image } from '../../common/assets.common';

SwiperCore.use([Pagination, Navigation]);
const VideoContainer = ({ _cl, inView, sponsorLogo = [], isSearchCard = false, gtmTagVariable = '' }) => {
  const { redirectTo } = useRedirect();
  const [showVideo, setShowVideo] = useState(false);
  const [loading, setLoading] = useState(false);
  const videoDetailsParent = useRef();
  const playerRef = useRef();
  const [aspectVideoContainerSize, setAspectVideoContainerSize] = useState('0px');
  const fallback_image = _cl.fallback_image ?? clinical_Video_static_image;
  const onReady = React.useCallback(() => {
    if (_cl?.play_time) {
      const timeToStart = _cl?.play_time;
      playerRef.current.seekTo(timeToStart, 'seconds');
    }
  }, [playerRef.current]);
  const handleVideoShow = () => {
    setLoading(true);
    setShowVideo(true);
    setTimeout(() => {
      setShowVideo(false);
    }, 30000);
  };
  const handleVideoClose = () => {
    setShowVideo(false);
    setLoading(false);
  };
  const setVideoConatinerSize = () => {
    if (videoDetailsParent.current) {
      const videoDivWidth = videoDetailsParent.current ? videoDetailsParent.current.clientWidth : 0;
      const aspectWidth = videoDivWidth / 1.7786;
      setAspectVideoContainerSize(aspectWidth > 0 ? Math.round(aspectWidth) : 0);
      // console.log('aspect size is' + aspectWidth);
    }
  };
  useEffect(() => {
    if (isMobile && !inView) {
      handleVideoClose();
    }
  }, [inView]);
  useEffect(() => {
    setVideoConatinerSize();
  }, []);
  function format(seconds) {
    const date = new Date(seconds * 1000);
    const hh = date.getUTCHours();
    const mm = pad(date.getUTCMinutes());
    const ss = pad(date.getUTCSeconds());
    if (hh) {
      return `${hh}:${mm}:${ss}`;
    }
    return `${mm}:${ss}`;
  }

  function pad(string) {
    return ('0' + string).slice(-2);
  }
  return (
    <div
      className="rounded clDbV2Pic cmnVideoBoxContainer position-relative overflow-hidden z-2 w-100"
      ref={videoDetailsParent}
      style={{ height: `${aspectVideoContainerSize}px` }}
      onMouseEnter={handleVideoShow}
      onMouseLeave={handleVideoClose}
      onTouchMove={handleVideoShow}
    >
      {!showVideo && (
        <>
          {sponsorLogo.length == 1 && (
            <div className="cmnVideosponser position-absolute rounded m-0 text-center py-2 px-3 bg-white">
              <div className="cmnVideosponserIn bg-white position-relative w-100">
                <LazyImage
                  src={sponsorLogo[0]}
                  className="position-absolute top-50 start-50 translate-middle mw-100 mh-100 w-auto h-auto"
                  alt="sponsor logo"
                  logo
                />
              </div>
            </div>
          )}

          {/* sponser logo if multiple */}
          {sponsorLogo?.length > 1 && (
            <Swiper
              className="cmnVideosponser position-absolute rounded m-0 text-center py-2 px-3 bg-white"
              navigation={false}
              spaceBetween={0}
              slidesPerView={1}
              loop={true}
              autoplay={{
                delay: 2500
              }}
              effect={'fade'}
            >
              {sponsorLogo?.map((logo) => {
                return (
                  <SwiperSlide className="cmnVideosponserIn bg-white position-relative w-100">
                    <LazyImage
                      src={logo}
                      className="position-absolute top-50 start-50 translate-middle mw-100 mh-100 w-auto h-auto"
                      alt="sponsor logo"
                      logo
                    />
                  </SwiperSlide>
                );
              })}
            </Swiper>
          )}
        </>
      )}
      {showVideo ? (
        <ReactPlayer
          className="cmnVideosDbV2Video position-absolute top-0 start-0"
          ref={playerRef}
          onReady={onReady}
          onStart={() => setLoading(false)}
          url={_cl?.src}
          playing={true}
          controls={false}
          width={'100%'}
          height={'100%'}
          muted={true}
          playsinline={true}
        />
      ) : null}

      <LazyImage
        src={_cl?.image ?? fallback_image}
        alt="cover image"
        className="object-fit-cover w-100 h-100 float-start"
        fallback_image={fallback_image}
      />
      <div
        className={`overlay cursorPointer d-flex align-items-center justify-content-center bg-black bg-opacity-25 ${
          loading ? 'dbClLoading' : ''
        } ${gtmTagVariable}`}
      >
        {/* {!showVideo && <RiPlayCircleFill customClass="text-white fs-72" />} */}
        {/* {loading && <img src={_cl.image} className="object-fit-cover w-100 h-100 float-start" />} */}
        <RiPlayCircleFill customClass="text-white fs-72 position-absolute top-50 start-50 translate-middle" />
        <Spinner animation="border" />
      </div>

      <div
        className={`w-100 h-100 cmnVideosTrigr cursorPointer position-absolute top-0 start-0 ${gtmTagVariable}`}
        onClick={() => redirectTo('ClinicalVideoDetails', _cl.type_id, _cl.question)}
      ></div>

      {_cl?.duration && (
        <span className="text-white fs-4 cmnVideoTime rounded position-absolute z-3 bg-black bg-opacity-75 py-2 px-3">
          {format(_cl?.duration)}
        </span>
      )}
      {loading && !isMobile && !isSearchCard && (
        <span className="text-white fs-4 cmnVideoKeep rounded position-absolute z-3 bg-dark bg-opacity-75 py-2 px-3">
          Keep hovering to preview
        </span>
      )}

      {_cl?.duration &&
        _cl?.play_time &&
        (parseInt(_cl?.play_time) / parseInt(_cl?.duration)) * 100 > 0 && (
          <ProgressBar
            className="position-absolute bottom-0 start-0 w-100 z-3 bg-white bg-opacity-50 rounded-0"
            now={(parseInt(_cl?.play_time) / parseInt(_cl?.duration)) * 100}
          />
        )}
    </div>
  );
};

export default memo(VideoContainer);
